import { EntitySales } from "../../entity/EntitySales";

export class DtoSalessDeleteRes extends EntitySales {
  public message: string | null = null;
}
